export default function useAddVideoPoster(html, img) {
  const insertPositon = html.indexOf("<video");
  if (insertPositon > 0) {
    return (
      html.slice(0, insertPositon + 6) +
      ' poster="' +
      img +
      '"' +
      html.slice(insertPositon + 6)
    );
  } else {
    return html;
  }
}
